import camelCase from 'camelcase';
export function getOrderRowPrice(p) {
    var price = p.product.price;
    p.extraServices
        .filter(function (s) { return s.isSelected; })
        .forEach(function (s) {
        price += s.price;
    });
    price = price * p.quantity;
    return price;
}
export function getExtraServiceTranslationKey(extraService, product) {
    if (!extraService) {
        return null;
    }
    var key = camelCase(extraService.code);
    if (extraService.code == "LargeContainer") {
        key += camelCase(product.productType, { pascalCase: true });
    }
    return "weeeCustomerOrder.extraService." + key;
}
